import React, { useState, useContext } from 'react';
import { ApolloProvider } from '@apollo/client';
import styled from 'styled-components';
import AuthContext from '../../contexts/AuthContext';
import { textGray } from '../../styles/colors';

import Unsubscribe from 'app/src/components/Unsubscribe';

import Login from './Login';
import AcceptInvite from './AcceptInvite';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

import DataState from '../DataState';
import Main from '../../Main';

const Screen = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 100px;
  animation: fadeIn 1s;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 65px;
  justify-content: center;
`;

const FooterLink = styled.a`
  text-align: center;
  text-decoration: none;
  color: ${textGray};
`;

const Auth = () => {
  const [
    showForgotPassword,
    setShowForgotPassword
  ] = useState(false);

  const {
    apolloClientForAuth,
    isLoggedIn,
    storageChecked,
  } = useContext(AuthContext);

  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get('inviteToken');
  const resetToken = params.get('resetToken');

  if (!storageChecked) {
    return <DataState.Loading />;
  }

  let content = <Login
    setShowForgotPassword={setShowForgotPassword}
  />;

  if ('/unsubscribe' === window.location.pathname) {
    content = <Unsubscribe />
  } else if (showForgotPassword) {
    content = <ForgotPassword setShowForgotPassword={setShowForgotPassword} />;
  } else if (resetToken) {
    content = <ResetPassword token={resetToken} />;
  } else if (inviteToken) {
    content = <AcceptInvite token={inviteToken} />;
  } else if (isLoggedIn) {
    content = <Main />;
  }

  return (
    <ApolloProvider client={apolloClientForAuth}>
      <Screen>
        <Content>
          {content}
        </Content>
      </Screen>
    </ApolloProvider>
  );
};

export default Auth;
